import {ModalType} from './ModalStore.types';

export const SHOW_OVERLAY_MODAL_TYPES = [
  ModalType.ProjectFinishesSoon,
  ModalType.AllItemsOpened,
  ModalType.ProjectFinished,
  ModalType.ItemLoading,
];
